import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { IPayoutLimit } from './types';

export const fetchPayoutLimitsRequest = async (): Promise<IPayoutLimit[] | null> => {
  try {
    const res = await axios.get('api/v1/payout/overall-limits');
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch payout limits");
    return null;
  }
};
